import { Component, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { InitializationService } from '../services/utility/initialization/initialization.service';
import { BillboardLabelDirective } from '../templates/global/billboard-label/billboard-label.directive';
import { buildPageTitle } from '../utilities/string';
import { SITEMAP_CATALOG } from './catalog/sitemap.catalog';
import { SitemapSearchService } from './sitemap-search.service';
import {
	SitemapApplication,
	SitemapAudience,
	SitemapEntry,
} from './sitemap.types';

@Component({
	selector: 'ae-sitemap',
	templateUrl: './sitemap.component.html',
	styleUrls: ['./sitemap.component.scss'],
	imports: [BillboardLabelDirective, ReactiveFormsModule],
})
export class SitemapComponent implements OnInit {
	protected readonly queryControl = new FormControl('', { nonNullable: true });
	protected readonly audienceControls: Readonly<
		Record<SitemapAudience, FormControl<boolean>>
	> = {
		user: new FormControl(true, { nonNullable: true }),
		customer: new FormControl(true, { nonNullable: true }),
		admin: new FormControl(true, { nonNullable: true }),
		superAdmin: new FormControl(true, { nonNullable: true }),
	};
	protected readonly applicationLabels: Readonly<
		Record<SitemapApplication, string>
	> = {
		admin: 'Admin',
		student: 'Student',
		wonder: 'Wonder',
		gabby: 'Gabby',
		dashboard: 'Dashboard',
		login: 'Login',
	};

	constructor(
		private readonly searchService: SitemapSearchService,
		private readonly title: Title,
		private readonly initializationService: InitializationService,
		private readonly router: Router,
	) {}

	ngOnInit(): void {
		if (!this.initializationService.hasAnyRole('staff')) {
			this.router.navigateByUrl('/');
			return;
		}

		this.title.setTitle(buildPageTitle('Sitemap'));
	}

	protected get results(): SitemapEntry[] {
		return this.searchService.search(SITEMAP_CATALOG, {
			query: this.queryControl.value,
			audiences: this.selectedAudiences,
			currentApplication: 'admin',
		});
	}

	private get selectedAudiences(): SitemapAudience[] {
		return (Object.keys(this.audienceControls) as SitemapAudience[]).filter(
			(audience) => this.audienceControls[audience].value,
		);
	}
}
